var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57288 7.24609L9.16663 3.52734H10.5104C10.9166 3.52734 11.2604 3.21484 11.2604 2.77734V1.27734C11.2604 0.871094 10.9166 0.527344 10.5104 0.527344H2.01038C1.57288 0.527344 1.26038 0.871094 1.26038 1.27734V2.77734C1.26038 3.21484 1.57288 3.52734 2.01038 3.52734H3.32288L2.91663 7.24609C1.41663 7.93359 0.260376 9.21484 0.260376 10.7773C0.260376 11.2148 0.572876 11.5273 1.01038 11.5273H5.26038V14.8086C5.26038 14.8398 5.26038 14.8711 5.26038 14.9023L6.01038 16.4023C6.10413 16.5898 6.38538 16.5898 6.47913 16.4023L7.22913 14.9023C7.22913 14.8711 7.26038 14.8398 7.26038 14.8086V11.5273H11.5104C11.9166 11.5273 12.2604 11.2148 12.2604 10.7773C12.2604 9.18359 11.0729 7.93359 9.57288 7.24609Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.b77b9020.svg";
export { ForwardRef as ReactComponent };